import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TypeaheadState } from './typeahead.reducer';

export const selectTypeaheadState = createFeatureSelector<TypeaheadState>('typeahead');
export const selectTypeaheadComponents = createSelector(selectTypeaheadState, (s) => (s ? s.components : undefined));
